import {useEffect, useState} from "react";
import {easeSinOut} from "d3-ease";
import {useFrame} from "@react-three/fiber";
import {useSpring} from "@react-spring/three";

export default function usePopOutEffect(objects, callback) {
  const [{ scale }, api] = useSpring(() => ({ scale: [1, 1, 1]}));
  const [playAnimation, setPlayAnimation] = useState(false);

  useEffect(() => {
    function setVisibilityToFalse() {
      for(let i=0; i < objects.length; i++) {
        objects[i].visible = false;
      }
    }

    function startAnimation() {
      scale.set([1, 1, 1]);
      api.start({
        scale: [0, 0, 0],
        config: { duration: 300, easing: easeSinOut },
        onRest: () => {
          setPlayAnimation(false);
          setVisibilityToFalse();
        }
      })
    }
    if(objects.length > 0) {
      startAnimation();
      setPlayAnimation(true);
    }


  }, [api, objects, scale])


  useFrame(() => {
    if(objects.length > 0 && playAnimation) {
      const currentScale = scale.get();
      for(let i=0; i < objects.length; i++) {
        objects[i].scale.x = currentScale[0];
        objects[i].scale.y = currentScale[1];
        objects[i].scale.z = currentScale[2];
      }
    }
  })
}
